<template>
  <div>
    <router-link v-if="isLayoutMobile" class="insight-link__link" :to="href">
      <div class="insight-link__content">
        {{ title }} <span class="insight-link__date">{{ date }}</span>
      </div>
    </router-link>
    <a v-else class="insight-link__link" :href="url" v-outer-link>
      <div class="insight-link__content">
        {{ title }} <span class="insight-link__date">{{ date }}</span>
      </div>
    </a>
  </div>
</template>
<script src="./insight-link.js"></script>
<style src="./insight-link.scss" lang="scss"></style>
